import React from 'react';

import StatusIndicator from '../components/StatusIndicator';
import { TileStatus } from '../EnvBased/DataMonitor';

interface FreshnessMonitorProps {
  dataStatus: TileStatus;
  title?: string;
  subtitle?: string;
  displaySubtitle?: boolean;
}

const JobBasedStatusInformation: React.FC<FreshnessMonitorProps> = ({
  dataStatus,
  title,
  subtitle,
  displaySubtitle,
}) => {
  return (
    <div className="px-8 py-4">
      <StatusIndicator dataStatus={dataStatus} />
      <div className="mx-auto flex items-center justify-center rounded-full py-1 text-center">
        <p className="items-center text-lg font-semibold">{title}</p>
      </div>
      <div className="mx-auto flex items-center justify-center rounded-full py-1 text-center">
        {displaySubtitle ? <p className="text-dbt-gray">{subtitle}</p> : <></>}
      </div>
    </div>
  );
};

export default JobBasedStatusInformation;
